<template>
<!-- 回到顶部 -->
    <div class="cornerbar">
        <div class="contact-btn" @click="toCooperation('cooperation')"><span></span>合作咨询</div>
        <div class="backTop-btn" v-if="btnFlag" @click="backTop"><i class="el-icon-arrow-up"></i></div>
    </div>
</template>

<script>
export default {
  props: {
    isSelf: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      btnFlag: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop () {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },

    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop () {
      const that = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
    toCooperation (id) {
      if (!this.isSelf) {
        localStorage.setItem('id', id)
        this.$router.push('/aboutUs')
      } else {
        document.getElementById('cooperation').scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
.cornerbar{
    position: fixed;
    left: 0;
    // right: 0;
    bottom: 40px;
    height: 169px;
    z-index: 10000;
    .contact-btn{
        width: 42px;
        height: 127px;
        padding: 10px;
        background: #007dff;
        border-radius: 2px;
        margin-bottom: 4px;
        color: #fff;
        font-size: 16px;
        line-height: 18px;
        text-align: center;
        cursor: pointer;
        span{
            display: block;
            width: 19px;
            height: 19px;
            margin: 0 auto;
            margin-bottom: 8px;
            background: url(../assets/icon/bd.png) no-repeat scroll center;
            background-size: 19px auto;
        }
    }
    .backTop-btn{
        width: 42px;
        height: 42px;
        line-height: 42px;
        margin-bottom: 0;
        border-radius: 2px;
        cursor: pointer;
        background: #007dff;
        color: #fff;
        text-align: center;
        font-size: 18px;
    }
}
</style>
